import { useRef } from "react"
import { useReactToPrint } from "react-to-print"
import { Paper } from "@mui/material"
import { Button } from "@mui/material"
import ReturnOrderReceipt from "."
import { mapReturnOrderToReceiptData } from "./return-order-mapper"
import { ReturnOrder } from "src/graphql/quark/quark.type"

const sampleReturnOrderPayload = {
  id: "81b639bc-0d04-495a-bc8e-0b6053100e0b",
  secondaryId: 1818,
  order: null,
  items: [
    {
      id: "956ec403-4816-41f9-87c1-3fbedae9f4b9",
      name: "NUBEROL TABLET FORTE 3X5S",
      quantity: 2,
      subTotal: 113.23,
      totalPrice: 113.23,
      discount: 0,
      unitPrice: 62.91,
      lots: [
        {
          productLot: {
            taxSellingUnit: 0
          }
        }
      ]
    }
  ],
  location: null,
  totalAmount: 113.23,
  paymentMethod: "CASH",
  locationRegisterSession: {
    openedBy: {
      firstName: "Nabeel ",
      secondaryId: null,
      lastName: "Sharif"
    }
  },
  status: "COMPLETED"
}

const DemoReturnReceipt = () => {
  const componentRef = useRef<HTMLDivElement>(null)

  // Handle print functionality with proper page setup
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle: `
      @page {
        size: 80mm auto;
        margin: 0mm;
      }
      @media print {
        body {
          margin: 0mm;
        }
      }
    `
  })

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => handlePrint()} sx={{ mb: 2 }}>
        Print Receipt
      </Button>

      <Paper elevation={2} sx={{ maxWidth: "90mm", mx: "auto" }}>
        {/* Pre-map and pass as generic receiptData */}
        <ReturnOrderReceipt
          receiptData={{
            ...mapReturnOrderToReceiptData(sampleReturnOrderPayload as ReturnOrder),
            fbrInvoiceId: "0000"
          }}
          receiptRef={componentRef}
        />
      </Paper>
    </>
  )
}

export default DemoReturnReceipt
